import React, { useState, useEffect, useRef } from "react"
import useTranslation from "../../../../../../hooks/use-translation";

import "./EditCowinDetails.css";

const CowinInputField = ({ label = "", value = "", error = "", _onChange = () => { } }) => {
  return <div className={`edit-cowin-details-input-wrapper ${error.length > 0 ? "error" : ""}`}>
    <div className={`edit-cowin-details-input-div ${error.length > 0 ? "error" : ""}`}>
      <div className="edit-cowin-details-input-label">
        {label}
      </div>
      <input className="edit-cowin-details-input-field" value={value} onChange={_onChange} />
    </div>
    {error.length > 0 &&
      <div className="edit-cowin-details-input-error">
        {error}
      </div>
    }
  </div>
}

const EditCowinDetails = ({ cowinName = "", cowinMobile = "", cowinRefId = "", _cancelClick = () => { }, _saveClick = async () => { }, apiError = "", _setApiError = () => {} }) => {
  const { t } = useTranslation();
  const [name, _setName] = useState(cowinName);
  const [mobile, _setMobile] = useState(cowinMobile);
  const [refId, _setRefId] = useState(cowinRefId);
  const [errors, _setErrors] = useState({ name: "", mobile: "", refId: "" })
  const [saving, _setSaving] = useState(false);
  const editDetailsRef = useRef();

  useEffect(() => {
    if (editDetailsRef) {
      editDetailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [])

  const _handleNameChange = (e) => {
    _setName(e.target.value);
    _setErrors({ ...errors, name: "" })
  }

  const _handleMobileChange = (e) => {
    _setMobile(e.target.value);
    _setErrors({ ...errors, mobile: "" })
  }

  const _handleRefIdChange = (e) => {
    _setRefId(e.target.value);
    _setErrors({ ...errors, refId: "" })
  }

  const _validateInputs = () => {
    let allowProceed = true;
    let newErrors = { ...errors };
    if (name === "") {
      newErrors.name = t("ENTER_NAME_ERROR");
      allowProceed = false
    }
    if (mobile === "" ) {
      newErrors.mobile = t("ENTER_MOBILE_ERROR");
      allowProceed = false
    }
    if (refId === "") {
      newErrors.refId = t("ENTER_REFID_ERROR");
      allowProceed = false
    }
    _setErrors(newErrors);
    return allowProceed;
  }

  const _handleSaveClick = async () => {
    _setApiError("");
    if (!_validateInputs()) {
      return;
    }
    _setSaving(true);
    await _saveClick(name, mobile, refId)
    _setSaving(false);
  }

  return <div className="edit-cowin-details-div" ref={editDetailsRef}>
    <div className="edit-cowin-details-header">
      {t("EDIT_COWIN_DETAILS")}
    </div>
    <CowinInputField label={t("COWIN_NAME")} value={name} error={errors.name} _onChange={_handleNameChange} />
    <CowinInputField label={t("COWIN_MOBILE")} value={mobile} error={errors.mobile} _onChange={_handleMobileChange} />
    <CowinInputField label={t("COWIN_REF_ID")} value={refId} error={errors.refId} _onChange={_handleRefIdChange} />
    <div className="edit-cowin-details-buttons">
      <button className={`edit-cowin-details-button ${saving ? "saving" : ""}`} onClick={_cancelClick} disabled={saving}>
        {t("CANCEL")}
      </button>
      <button className={`edit-cowin-details-button save ${saving ? "saving" : ""}`} onClick={_handleSaveClick} disabled={saving}>
        {t("SAVE")}
      </button>
    </div>
    <div className="api-error">{apiError}</div>
  </div>
}

export default EditCowinDetails;